<template>
  <nav class="sidebar-main">
    <div class="left-arrow" :class="isActive ? '' : 'disabled'" id="left-arrow" @click="display2()">

      <vue-feather type="arrow-left"></vue-feather>
    </div>
    <div id="sidebar-menu" :style="{ marginLeft: this.sidebar == 'horizontal-wrapper' ? this.margin + 'px' : '0px' }">
      <ul class="sidebar-links custom-scrollbar" id="simple-bar">
        <li class="back-btn"><a><router-link to="/"><img class="img-fluid for-light"
                src="@/assets/images/logo/logo-icon.png" alt=""><img class="img-fluid for-dark"
                src="@/assets/images/logo/logo-icon-dark.png" alt=""></router-link></a>
          <div class="mobile-back text-end"><span>Back</span><i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
          </div>
        </li>
        <navMenuList :show="true" @settingsActive="display" v-for="(link, index) in menuItems" :link="link"
          :key="index" />

      </ul>
      <div class="sidebar-img-section">
        <div class="sidebar-img-content"><img class="img-fluid" src="@/assets/images/dashboard/upgrade/2.png" alt="">
          <h4>Experiance with more Features</h4><a class="btn btn-primary"
            href="https://themeforest.net/user/pixelstrap/portfolio" target="_blank">Check now</a>
        </div>
      </div>
    </div>
    <div class="right-arrow" id="right-arrow" @click="display()"><vue-feather type="arrow-right"></vue-feather></div>
  </nav>
</template>

<script>
import navMenuList from './navMenuList.vue'
import {
  mapState, mapGetters
} from 'vuex'

export default {
  name: "navMenu",
  components: {

    navMenuList
  },
  data() {
    return {
      isActive: false,
      layoutType: 'ltr',
      mixLayout: 'default',
      margin: 0,

    }
  },
  computed: {
    ...mapState({
      isActive: state => state.isActive,
      menuItems: state => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
      width: (state) => state.menu.width,
      height: (state) => state.menu.height,
      margin: (state) => state.menu.margin,
      menuWidth: (state) => state.menu.menuWidth,
      layout: state => state.layout.layout,
      sidebar: state => state.layout.sidebarType,
    }),
    ...mapGetters({
      sidebar: 'layout/sidebar'
    }),
  },
  watch: {
    menutItems() {

    }
  },
  methods: {
    display() {

      if (this.isActive == false) {
        this.isActive = !this.isActive
      }

      if (this.margin >= -4500 && this.sidebar == "horizontal-wrapper") {
        this.margin = this.margin - 500

      }
    },
    display2() {
      if (this.margin <= 500)
        this.margin = this.margin + 500
    },
    customizeLayoutType(val) {
      this.$store.dispatch('layout/setLayoutType', val);
      this.layoutType = val;
    },
    customizeMixLayout(val) {
      this.mixLayout = val;
      this.$store.dispatch('layout/setLayout', val);
    },
    setNavActive(item) {
      this.$store.dispatch('menu/setNavActive', item);

    },
    hidesecondmenu() {
      if (window.innerWidth < 991) {
        this.$store.state.menu.activeoverlay = false,
          this.$store.state.menu.togglesidebar = false;
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });

      }
    },

  },
  mounted() {
    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.$store.dispatch('menu/setActiveRoute', items);
      if (!items.children) return false;
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', subItems);
        if (!subItems.children) return false;
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subSubItems);
        });
      });
    });
  }
}
</script>
